module.exports = __webpack_public_path__ + "img/history.1d792697.jpg";